<aside class="sidebar">
  <div class="sidebar-header">
    <div class="logo-container">
      <div class="logo-icon"></div>
      <div class="logo-text">Trichology CRM</div>
    </div>
  </div>
  
  <nav class="nav-menu">
    <a class="nav-item" 
       *ngFor="let item of navItems"
       [routerLink]="item.route"
       routerLinkActive="active"
       [routerLinkActiveOptions]="{ exact: true }">
      <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
      <span class="nav-label">{{ item.label }}</span>
    </a>
  </nav>
  
  <div class="sidebar-bottom">
    <a class="support-link">
      <mat-icon class="nav-icon">help_outline</mat-icon>
      <span class="nav-label">Support</span>
    </a>
  </div>
</aside> 
